import React from 'react';
import { useNavigate } from 'react-router-dom';
import { compose } from 'recompose';

import { withApollo } from 'react-apollo';
import auth from 'shared-components/src/utils/auth';
import { get } from 'shared-components/src/utils/http';
import Sidebar from './Sidebar';

const ComposedSidebar = compose(withApollo)(Sidebar);

// Wrapper to provide logout handler using React Router v6 hooks
export default function SidebarWrapper(props) {
  const navigate = useNavigate();

  const logout = async () => {
    try {
        // Call backend to revoke refresh tokens
        await get('/api/logout');
      } catch (error) {
        // Ignore errors - still logout on frontend
        console.warn('Logout API call failed:', error);
      } finally {
        // Clear local storage and redirect
        auth.logout().then(() => navigate('/auth/login'));
      }
  };

  return <ComposedSidebar {...props} logout={logout} />;
}
